export const SousDispositifDRF = ['CDPI', 'CIPI'] as const
export const SousDispositifFormation = ['AfFpe', 'CAR'] as const
export const SousDispositif = [...SousDispositifDRF, ...SousDispositifFormation] as const

export type SousDispositifDRF = (typeof SousDispositifDRF)[number]
export type SousDispositifFormation = (typeof SousDispositifFormation)[number]
export type SousDispositif = (typeof SousDispositif)[number]

export const SousDispositifLibelle: Record<SousDispositif, string> = {
  AfFpe: 'Action formation FPE',
  CAR: 'Contrat d’alternance reconversion (CAR)',
  CDPI: 'Contrat de Développement Professionnel Intérimaire (CDPI)',
  CIPI: 'Contrat d’Insertion Professionnelle Intérimaire (CIPI)',
} as const
